
import { useState, useEffect } from 'react';

export default function LineFloatingButton() {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 2000);

    const tooltipTimer = setTimeout(() => {
      setShowTooltip(true);
      setTimeout(() => setShowTooltip(false), 5000);
    }, 4000);

    return () => {
      clearTimeout(timer);
      clearTimeout(tooltipTimer);
    };
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 right-4 md:bottom-6 md:right-6 z-50 flex flex-col items-end gap-2 md:gap-3">
      {showTooltip && (
        <div className="bg-white rounded-xl md:rounded-2xl shadow-2xl p-3 md:p-4 max-w-[180px] md:max-w-[220px] animate-bounce-in border border-gray-100 relative">
          <button
            onClick={() => setShowTooltip(false)}
            className="absolute -top-2 -right-2 w-5 h-5 md:w-6 md:h-6 bg-gray-200 rounded-full flex items-center justify-center text-gray-600 hover:bg-gray-300 transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-xs md:text-sm"></i>
          </button>
          <p className="text-xs md:text-sm font-bold text-gray-900 mb-1">LINEでお気軽に相談！</p>
          <p className="text-[10px] md:text-xs text-gray-600 leading-relaxed">写真を送るだけで簡単お見積もり。24時間受付中です。</p>
          <div className="absolute bottom-[-8px] right-4 md:right-6 w-3 h-3 md:w-4 md:h-4 bg-white border-r border-b border-gray-100 transform rotate-45"></div>
        </div>
      )}
      <a
        href="https://lin.ee/Rm6h2gK"
        target="_blank"
        rel="noopener noreferrer"
        className="group flex items-center gap-2 md:gap-3 bg-[#06C755] text-white rounded-full shadow-2xl hover:shadow-3xl transition-all hover:scale-110 cursor-pointer"
        onMouseEnter={() => setShowTooltip(false)}
      >
        <div className="flex items-center gap-1.5 md:gap-2 pl-4 pr-5 md:pl-5 md:pr-6 py-2.5 md:py-3.5">
          <i className="ri-line-fill text-xl md:text-2xl"></i>
          <span className="text-xs md:text-sm font-bold whitespace-nowrap">LINE相談</span>
        </div>
      </a>
    </div>
  );
}
